import p1 from "../assets/images/allprojects/exploreprojects/p1.png";
import p2 from "../assets/images/allprojects/exploreprojects/p2.jpg";
import p3 from "../assets/images/allprojects/exploreprojects/p3.jpg";
import p4 from "../assets/images/allprojects/exploreprojects/p4.jpg";
import p5 from "../assets/images/allprojects/exploreprojects/p5.jpg";

export const projectsData = [
  {
    id: "1",
    title: "Palm towers",
    description:
      "IRQGYP was founded with a clear mission: to modernize Iraq's construction industry through high-quality gypsum products and reliable technical expertise. Headquartered in Baghdad with operations in Erbil, we combine advanced production facilities with a skilled local workforce to deliver solutions that meet international standards - EN and ASTM - while remaining deeply committed to Iraq's growth and development.",
    highlight:
      "IRQGYP was founded with a clear mission: to modernize Iraq's construction industry through high-quality gypsum products and reliable technical expertise.",
    location: "Iraq - Baghdad - distinguished Al-Muthanna area",
    sector: "Sector name",
    image: p1,
  },
  {
    id: "2",
    title: "Palm towers",
    description:
      "IRQGYP was founded with a clear mission: to modernize Iraq's construction industry through high-quality gypsum products and reliable technical expertise. Headquartered in Baghdad with operations in Erbil, we combine advanced production facilities with a skilled local workforce to deliver solutions that meet international standards - EN and ASTM - while remaining deeply committed to Iraq's growth and development.",
    highlight:
      "IRQGYP was founded with a clear mission: to modernize Iraq's construction industry through high-quality gypsum products and reliable technical expertise.",
    location: "Iraq - Baghdad - distinguished Al-Muthanna area",
    sector: "Sector name",
    image: p2,
  },
  {
    id: "3",
    title: "Palm towers",
    description:
      "IRQGYP was founded with a clear mission: to modernize Iraq's construction industry through high-quality gypsum products and reliable technical expertise. Headquartered in Baghdad with operations in Erbil, we combine advanced production facilities with a skilled local workforce to deliver solutions that meet international standards - EN and ASTM - while remaining deeply committed to Iraq's growth and development.",
    highlight:
      "IRQGYP was founded with a clear mission: to modernize Iraq's construction industry through high-quality gypsum products and reliable technical expertise.",
    location: "Iraq - Baghdad - distinguished Al-Muthanna area",
    sector: "Sector name",
    image: p3,
  },
  {
    id: "4",
    title: "Palm towers",
    description:
      "IRQGYP was founded with a clear mission: to modernize Iraq's construction industry through high-quality gypsum products and reliable technical expertise. Headquartered in Baghdad with operations in Erbil, we combine advanced production facilities with a skilled local workforce to deliver solutions that meet international standards - EN and ASTM - while remaining deeply committed to Iraq's growth and development.",
    highlight:
      "IRQGYP was founded with a clear mission: to modernize Iraq's construction industry through high-quality gypsum products and reliable technical expertise.",
    location: "Iraq - Baghdad - distinguished Al-Muthanna area",
    sector: "Sector name",
    image: p4,
  },
  {
    id: "5",
    title: "Palm towers",
    description:
      "IRQGYP was founded with a clear mission: to modernize Iraq's construction industry through high-quality gypsum products and reliable technical expertise. Headquartered in Baghdad with operations in Erbil, we combine advanced production facilities with a skilled local workforce to deliver solutions that meet international standards - EN and ASTM - while remaining deeply committed to Iraq's growth and development.",
    highlight:
      "IRQGYP was founded with a clear mission: to modernize Iraq's construction industry through high-quality gypsum products and reliable technical expertise.",
    location: "Iraq - Baghdad - distinguished Al-Muthanna area",
    sector: "Sector name",
    image: p5,
  },
];

